export default "__VITE_ASSET__Ck7t_mfJ__"